import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useRootStore } from '@qsrsoft/myq-core';

export function useCommsHubComposable() {
  const store = useRootStore();
  const { enterpriseClient } = storeToRefs(store);
  const isCommsHub = computed(
    () => enterpriseClient.value?.toLowerCase() === 'commshub',
  );

  return { isCommsHub };
}
